import type { LogsInitConfiguration } from '@datadog/browser-logs';
import {
  NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  NEXT_PUBLIC_DATADOG_SERVICE_NAME,
  NEXT_PUBLIC_DATADOG_SITE,
  NEXT_PUBLIC_RELEASE_VERSION,
} from '@env';
import { type DatadogEnv, getDatadogEnv } from '@modules/monitoring/datadog-env';

const sharedLogsInitConfig: LogsInitConfiguration = {
  clientToken: NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  site: NEXT_PUBLIC_DATADOG_SITE,
  service: NEXT_PUBLIC_DATADOG_SERVICE_NAME,
  version: NEXT_PUBLIC_RELEASE_VERSION,
  forwardErrorsToLogs: true,
  forwardConsoleLogs: 'all',
  forwardReports: 'all',
};

const logsInitConfigs: { [key in DatadogEnv]: LogsInitConfiguration } = {
  production: {
    ...sharedLogsInitConfig,
    sessionSampleRate: 100,
    env: 'production',
  },
  'non-production': {
    ...sharedLogsInitConfig,
    sessionSampleRate: 100,
    env: 'non-production',
  },
  preview: {
    ...sharedLogsInitConfig,
    sessionSampleRate: 100,
    env: 'preview',
  },
};

/**
 * Resolve the browser Logs init configuration for the current deployment environment.
 *
 * Returns `null` in environments where we don't emit logs (local dev). The actual
 * `datadogLogs.init` call lives in `instrumentation-client.ts`: the SDK forwards
 * `console.*`, and anything logged before `init` is dropped, so it has to be up
 * before any component mounts.
 */
export function getLogsInitConfig(): LogsInitConfiguration | null {
  const datadogEnv = getDatadogEnv();
  return datadogEnv ? logsInitConfigs[datadogEnv] : null;
}
